<div class="feedback-container">
  <!-- SUBMITTED NOW -->
  <div *ngIf="submitted" class="feedback-card thank-you">
    <div class="ty-icon">✦</div>
    <h2>{{ "feedback.thanks" | translate }}</h2>
    <p>{{ "feedback.thanks_desc" | translate }}</p>
    <div class="beta-promise">
      <span class="beta-badge-large">BETA</span>
      <p>{{ "feedback.beta_discount" | translate }}</p>
    </div>
    <button class="btn-gold" (click)="router.navigate(['/home'])">
      {{ "feedback.back_home" | translate }}
    </button>
  </div>

  <!-- FORM -->
  <div *ngIf="!submitted" [formGroup]="form">
    <!-- HEADER -->
    <div class="feedback-header">
      <span class="beta-badge-large">BETA</span>
      <h1>{{ "feedback.title" | translate }}</h1>
      <p>{{ "feedback.subtitle" | translate }}</p>
    </div>

    <!-- CARD NPS -->
    <div class="feedback-card">
      <h3>{{ "feedback.nps" | translate }}</h3>
      <p class="hint">{{ "feedback.nps_hint" | translate }}</p>
      <div class="nps-row">
        <button
          *ngFor="let n of npsLabels"
          class="nps-btn"
          [class.selected]="npsScore === n"
          [class.low]="n <= 4"
          [class.mid]="n >= 5 && n <= 7"
          [class.high]="n >= 8"
          (click)="setNps(n)"
        >
          {{ n }}
        </button>
      </div>
      <div class="nps-legend">
        <span>{{ "feedback.nps_legend_low" | translate }}</span>
        <span>{{ "feedback.nps_legend_high" | translate }}</span>
      </div>
    </div>

    <!-- CARD ABBONAMENTO -->
    <div class="feedback-card">
      <h3>{{ "feedback.subscription" | translate }}</h3>
      <p class="hint">{{ "feedback.subscription_hint" | translate }}</p>
      <div class="radio-group">
        <label
          class="radio-card"
          [class.selected]="form.value.interested_subscription === true"
        >
          <input
            type="radio"
            formControlName="interested_subscription"
            [value]="true"
          />
          <span class="radio-label">{{ "feedback.yes" | translate }}</span>
        </label>
        <label
          class="radio-card"
          [class.selected]="form.value.interested_subscription === false"
        >
          <input
            type="radio"
            formControlName="interested_subscription"
            [value]="false"
          />
          <span class="radio-label">{{ "feedback.no" | translate }}</span>
        </label>
      </div>

      <!-- PREZZO — solo se interessata -->
      <div
        *ngIf="form.value.interested_subscription === true"
        class="price-section"
      >
        <label>{{ "feedback.price_label" | translate }}</label>
        <div class="chip-group">
          <label
            *ngFor="let p of priceRanges"
            class="chip"
            [class.selected]="form.value.price_range === p.id"
          >
            <input
              type="radio"
              formControlName="price_range"
              [value]="p.id"
              hidden
            />
            {{ p.label }}
          </label>
        </div>
      </div>
    </div>

    <!-- CARD FUNZIONALITÀ -->
    <div class="feedback-card">
      <h3>{{ "feedback.features" | translate }}</h3>
      <p class="hint">{{ "feedback.features_hint" | translate }}</p>
      <div class="chip-group">
        <button
          *ngFor="let f of features"
          type="button"
          class="chip"
          [class.selected]="isFeatureSelected(f.id)"
          (click)="toggleFeature(f.id)"
        >
          {{ f.label }}
        </button>
      </div>
    </div>

    <!-- CARD COSA MANCA -->
    <div class="feedback-card">
      <h3>{{ "feedback.missing" | translate }}</h3>
      <p class="hint">{{ "feedback.missing_hint" | translate }}</p>
      <textarea
        formControlName="missing_features"
        [placeholder]="'feedback.missing_placeholder' | translate"
        rows="4"
      ></textarea>
    </div>

    <!-- BETA PROMISE -->
    <div class="beta-promise-banner">
      <span class="beta-badge-large">BETA</span>
      <div>
        <strong>{{ "feedback.beta_promise_title" | translate }}</strong>
        <p>{{ "feedback.beta_promise_desc" | translate }}</p>
      </div>
    </div>

    <!-- SUBMIT -->
    <div class="submit-row">
      <button class="btn-gold btn-submit" (click)="submit()">
        {{ alreadySubmitted ? ("feedback.update" | translate) : ("feedback.submit" | translate) }}
      </button>
    </div>
  </div>
</div>
